import SignOutMutation from '../graphql/mutations/SignOutMutation';

const onSignOut = () => {
  SignOutMutation(() => {
    window.location = '/account/signedout';
  });
};

export default onSignOut;
